<template>
  <div
    id="brandbar-host"
    v-if="brandbar_show"
    class="d-flex flex-column justify-start align-center"
    style="position: fixed; width: 100%; z-index: 4000"
  >
    <!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-dialog v-model="show_search_diag" style="z-index: 5000">
      <v-card
        elevation="=2"
        class="wellbeing"
        style="max-width: 1025px; margin: auto"
      >
        <v-card-title class="white--text">
          Find Search Term in Text
        </v-card-title>
        <v-card-subtitle class="white--text"
          >Clear and Search to remove filter.</v-card-subtitle
        >
        <v-card-text>
          <v-container>
            <div
              style="background-color: white; border-radius: 4px"
              class="pa-6"
            >
              <v-text-field
                clearable
                v-model="sterm"
                maxlength="60"
                :counter="60"
                label="Search Term"
                required
                @keydown.enter.prevent="search"
              ></v-text-field>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="search"
          >
            <v-icon small>$search</v-icon>
            Search</v-btn
          >
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="clear_search"
          >
            <v-icon small>$cancel1</v-icon>
            Clear Search</v-btn
          >
          <v-btn
            outlined
            small
            elevation="2"
            class="white--text"
            @click="cancel_search_diag"
          >
            Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div id="v-app-bar--contatiner" class="d-flex app-bar-size wellbeing">
      <v-navigation-drawer
        id="v-navigation-drawer"
        height="105"
        v-model="drawer"
        temporary
        absolute
        app
        class="drawer_pos mt-8"
      >
        <v-list nav dense close-on-click close-on-content-click>
          <v-list-item-group v-model="group" active-class="primary white--text">
            <v-list-item @click.prevent="menu_home">
              <v-list-item-icon>
                <v-icon color="blue darken-4">$home</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click.prevent="email_brand">
              <v-list-item-title>Email</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar
        fixed
        app
        class="mx-auto wellbeing app-bar-size"
        absolute
        dense
        style="color: white !important; max-width: 1025px; box-shadow: none"
      >
        <v-app-bar-nav-icon
          id="v-app-bar-nav-icon"
          v-show="true"
          x-large
          @click="show_drawer"
        ></v-app-bar-nav-icon>
        <v-spacer></v-spacer>

        <v-img
          class="mt-8 logo-img-size"
          src="../images/logo happy energy white 138 v2.png"
        ></v-img>
        <v-spacer></v-spacer>
        <div id="div_logoff">
          <v-btn icon text v-show="true" @click="toggle_logoff">
            <v-icon x-large>$person</v-icon>
          </v-btn>
        </div>
      </v-app-bar>
    </div>

    <div
      id="app-title-tool-cont"
      class="w100 d-flex flex-column justify-start align-center"
      style="display: none"
    >
      <!-- <div
        id="app-title-container"
        style="width: 100%; height: 31px"
        class="d-flex"
      >
        <v-spacer></v-spacer>
        <div
          id="apptitle"
          style="
            color: white !important;
            max-width: 1025px;
            width: 100%;
            height: 30px;
            text-align: center;
            vertical-align: middle;
          "
          class="wellbeing"
        >
          <span class="text-h6" style="">{{ app_title }}</span>
        </div>

        <v-spacer></v-spacer>
      </div> -->
      <div
        v-if="show_user_controls"
        id="toobar-host"
        class="w100 d-flex flex-column justify-start align-center pa-0 ma-0"
      >
        <v-card class="w100 pa-1 ma-0 wellbeing py-0 brd-radius-tools">
          <v-card-actions class="d-flex justify-center py-0 mt-2">
            <v-btn
              @click="go_to_email"
              small
              elevation="2"
              class="wellbeing3 white--text"
            >
              <v-icon small>$info</v-icon>
              Tips or Suggestions</v-btn
            >
            <v-btn
              small
              elevation="2"
              class="wellbeing4 white--text"
              @click="search_diag"
            >
              <v-icon small>$search</v-icon>
            </v-btn>
            <v-btn
              v-if="show_admin_edit_button"
              small
              elevation="2"
              class="blue accent-3 white--text"
              @click="toggle_admin_edit"
            >
              <v-icon v-if="show_admin_controls == false" small>$edit</v-icon>
              <v-icon v-if="show_admin_controls == true" small>$eye</v-icon>
            </v-btn>

            <!-- <v-text-field
              dark
              class="ml-8 text-white hide-small"
              label="Search"
              prepend-icon="$textSearch"
              clearable
              style="max-width: 200px; position: relative; top: 3px"
            ></v-text-field> -->
          </v-card-actions>
          <v-card-actions class="pa-0 mt-2">
            <v-container class="pa-0">
              <div
                id="tab-host"
                class="w100 d-flex justify-center flex-wrap pb-1"
              >
                <v-btn-toggle
                  active-class="btn-active"
                  btn-active
                  v-model="tabs"
                  tile
                  color="blue"
                  group
                  @change="btn_change"
                >
                  <!-- hidden on xs -->
                  <div
                    class="d-none d-sm-flex flex-row justify-center flex-wrap"
                  >
                    <v-btn value="mental" class="btn-inactive">
                      Mental Health</v-btn
                    >

                    <v-btn value="peer" class="btn-inactive"> Peer </v-btn>

                    <v-btn value="physical" class="btn-inactive">
                      Physical
                    </v-btn>

                    <v-btn value="spiritual" class="btn-inactive">
                      Spiritual
                    </v-btn>
                    <v-btn value="resil" class="btn-inactive">
                      Resiliency
                    </v-btn>
                  </div>
                  <!-- hidden on md -->
                  <div class="d-flex d-sm-none justify-center flex-wrap">
                    <v-btn x-small value="mental" class="btn-inactive">
                      Mental
                    </v-btn>

                    <v-btn x-small value="peer" class="btn-inactive">
                      Peer
                    </v-btn>

                    <v-btn x-small value="physical" class="btn-inactive">
                      Physical
                    </v-btn>

                    <v-btn x-small value="spiritual" class="btn-inactive">
                      Spiritual
                    </v-btn>
                    <v-btn x-small value="resil" class="btn-inactive">
                      Resiliency
                    </v-btn>
                  </div>
                </v-btn-toggle>
              </div>
            </v-container>
          </v-card-actions>
          <v-card-text class="d-flex justify-center" v-if="sterm_str">
            <h6 style="font-size: 1.4rem" class="white--text">
              Search Term: '{{ sterm }}'
            </h6>
          </v-card-text>
          <!-- <div class="w100 d-flex justify-center py-0">
            <v-text-field
              dark
              class="text-white hide-large py-0"
              label="Search"
              prepend-icon="$textSearch"
              clearable
              style="max-width: 200px"
            ></v-text-field>
          </div> -->
        </v-card>
      </div>
    </div>

    <div
      id="logoff-popup"
      class="text-white"
      @click="logoff"
      style="
        z-index: 500;
        background-color: aliceblue;
        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 50px;
        padding: 10px;
        border-radius: 4px;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>
  </div>
</template>

<style scoped>
.text-white input {
  color: white;
}
@media (min-width: 0px) {
  .hide-small {
    display: none;
  }
  .logo-img-size {
    max-width: 86px;
    height: auto;
    width: 138px;
  }
  .app-bar-size {
    height: 74px;
    width: 100%;
  }
  .brd-radius-tools {
    border-radius: 0 0 20px 20px;
  }
  .wellbeinga {
    background: linear-gradient(
      90deg,
      #4966cf,
      #5d6cd4,
      #6e72d8,
      #7e78dd,
      #8d7ee1,
      #9c7ee2,
      #aa7ee3,
      #b87ee3,
      #cb77dd,
      #dc70d5,
      #ec67ca,
      #fb5fbe
    );
  }
  .wellbeing {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#3555c9+0,485ace+9,565ad2+18,6961d7+27,7765db+36,8864dc+45,9965dd+55,a965dd+64,c15fd7+73,d658ce+82,e94dc2+91,fa40b3+100 */
    background: linear-gradient(
      to right,
      #3555c9 0%,
      #485ace 9%,
      #565ad2 18%,
      #6961d7 27%,
      #7765db 36%,
      #8864dc 45%,
      #9965dd 55%,
      #a965dd 64%,
      #c15fd7 73%,
      #d658ce 82%,
      #e94dc2 91%,
      #fa40b3 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }
  .wellbeing2 {
    background: linear-gradient(270deg, #cb77dd, #dc70d5, #ec67ca, #fb5fbe);
  }
  .wellbeing3 {
    background: linear-gradient(
      270deg,
      #7e78dd,
      #8d7ee1,
      #9c7ee2,
      #aa7ee3,
      #b87ee3
    );
  }
  .wellbeing4 {
    background: linear-gradient(270deg, #4966cf, #5d6cd4, #6e72d8, #7e78dd);
  }
  .crazy_orange {
    background: radial-gradient(
      circle at -8.9% 51.2%,
      rgb(255, 124, 0) 0%,
      rgb(255, 124, 0) 20%.9%,
      rgb(255, 163, 77) 20%.9%,
      rgb(255, 163, 77) 30.4%,
      rgb(19, 30, 37) 30.4%,
      rgb(0, 0, 0) 76%
    );
  }
  .btn-inactive {
    color: rgba(256, 256, 256, 0.5) !important;
    background-color: transparent !important;
  }

  .btn-active {
    color: rgb(256, 256, 256) !important;
    background-color: rgba(0, 0, 256 0.5) !important;
  }
  .tool_btn1 {
    width: 250px;
  }
  .toobar-host {
    max-width: none;
  }
  .w100 {
    width: 100%;
  }
  .w90 {
    width: 93%;
  }
  .drawer_pos {
    left: 30%;
    top: 150px;
  }
  i.v-icon.v-icon {
    color: red;
  }

  .v-icon {
    color: #ffffff !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .logo-img-size {
    max-width: 172px;
    height: auto;
    width: 138px;
  }
  .app-bar-size {
    height: 108px;
    width: 100%;
    max-width: 1025px;
  }
  #toobar-host {
    max-width: 1025px;
  }
  .hide-small {
    display: flex;
  }
  .hide-large {
    display: none;
  }
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "brandbar",
  mixins: [bus_common],
  data: function () {
    return {
      sterm: "",
      valid: true,
      show_search_diag: false,
      tabs: "mental",
      brandbar_show: true,
      showLogoff: false,
      user_email: "",
      app_title: "Well Being",
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      } else {
        this.user_email = "UNKNOWN";
      }
    },
    "$store.state.brandbar_show": function () {
      this.brandbar_show = this.$store.state.brandbar_show;
    },
  },
  computed: {
    show_user_controls() {
      return this.$store.state.show_user_controls;
    },
    show_admin_controls() {
      return this.$store.state.show_admin_controls;
    },
    show_admin_edit_button() {
      return this.$store.state.show_admin_edit_button;
    },
    sterm_str() {
      if (this.$store.state.sterm != null && this.$store.state.sterm != "") {
        return this.$store.state.sterm.length > 2 ? true : false;
      } else {
        return false;
      }
    },
  },
  methods: {
    email_brand() {
      this.$router.push({
        path: "/email_brand",
        query: { token: this.$store.state.user.token },
      });
    },
    go_to_email() {
      this.$router.push({
        path: "/email",
        query: { token: this.$store.state.user.token },
      });
    },
    sec_wit() {
      window.location.href = "https://secretwitness.com/report/";
    },
    show_drawer() {
      //this.mrbreakpoint("show");
      var bar = document.getElementById("v-app-bar-nav-icon");
      var rect = bar.getBoundingClientRect();
      var daDrawer = document.getElementById("v-navigation-drawer");
      daDrawer.style.left = rect.left + "px";
      this.drawer = true;
    },
    email_form() {
      alert("An email form will coming soon.");
      this.drawer = false;
    },
    cancel_search_diag() {
      this.show_search_diag = false;
    },
    search() {
      this.$store.commit("set_Sterm", this.sterm);
      this.show_search_diag = false;
    },
    clear_search() {
      this.sterm = "";
      this.$store.commit("set_Sterm", "");
      this.show_search_diag = false;
    },
    search_diag() {
      this.show_search_diag = true;
    },
    btn_change() {
      this.$store.commit("set_tabs", this.tabs);
    },
    toggle_admin_edit() {
      this.$store.commit(
        "setShow_admin_controls",
        !this.$store.state.show_admin_controls
      );
    },
    menu_home() {
      this.$router.push("/?token=" + this.$store.state.user.token);
      this.drawer = false;
    },
    menu_help() {
      this.$router.push("/help?token=" + this.$store.state.user.token);
    },
    toggle_logoff() {
      var bar = document.getElementById("v-app-bar-nav-icon");
      var rect = bar.getBoundingClientRect();
      this.showLogoff = !this.showLogoff;
      if (this.showLogoff) {
        setTimeout(() => {
          //this.mrbreakpoint("things");
          var lg = document.getElementById("logoff-popup");
          lg.style.right = rect.right + "px";
        }, 200);
      }
    },
    logoff() {
      window.location.replace("https://rpdlogin.org/");
    },
  },
  mounted() {
    // var auser = {
    //   email: "jvonmolt@gmail.com",
    //   roles: "allroles",
    //   token: "fauxtoken",
    //   rpduserId: 0,
    //   auth: true,
    // };
    // this.$store.commit("setUser", auser);
    //console.log("befopre time out " + this.$store.state.user.roles);
    let count = 0;
    let chkthis = setInterval(() => {
      count++;
      if (count >= 20) {
        clearInterval(chkthis);
      }
      console.log(
        "chk admin: " + this.$store.state.user.roles.indexOf("well-admin")
      );
      // console.log("after time out " + this.$store.state.user.roles);
      //  console.log(this.$store.state.user.roles);
      if (this.$store.state.user.roles.indexOf("well-admin") != -1) {
        this.$store.commit("set_Show_admin_edit_button", true);
        clearInterval(chkthis);
      }
    }, 250);
  },
};
</script>
